import coach_image from 'assets/bus_images/Coach_image.jpg'
import single_decker_image from 'assets/bus_images/Single_decker_image.jpg'
import double_decker_image from 'assets/bus_images/Double_decker_image.jpg'
import default_bus_image from 'assets/images/bus.png'

export const bus_img_data: any = {
  coach: coach_image,
  single_decker: single_decker_image,
  double_decker: double_decker_image,
  default_img: default_bus_image,
}
